import { render, staticRenderFns } from "./ImpedimentoVisual.vue?vue&type=template&id=fa42065a"
import script from "./ImpedimentoVisual.vue?vue&type=script&lang=js"
export * from "./ImpedimentoVisual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports